/**
 * Mio Page Fade-In — IntersectionObserver that adds .visible to .mio-fade-in elements.
 * Also sets --header-container-height CSS variable from the header element.
 *
 * - No-JS safe: elements are visible by default. This script adds the
 *   `mio-fade-ready` class to <html>, and the hidden state in
 *   mio-page-shared.css only applies under that class. If the script never
 *   runs, nothing is hidden.
 * - Reduced motion: when prefers-reduced-motion is set, the class is never
 *   added — content shows immediately, no animation.
 * - Idempotent: this file is included once per section instance (up to 5x per
 *   page). A window guard keeps a single observer; re-runs only pick up
 *   .mio-fade-in elements added since (e.g. theme editor section reloads).
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var observer = window.__mioPageFadeInObserver;

    if (!observer) {
      document.documentElement.classList.add('mio-fade-ready');
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
      );
      window.__mioPageFadeInObserver = observer;
    }

    document.querySelectorAll('.mio-fade-in:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Set header height variable for hero sizing (safe to re-run) */
  var header = document.querySelector('header');
  if (header) {
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-container-height', h + 'px');
  }
})();
